import { Box, Typography } from "@mui/material";
import RemoveAction from "./RemoveAction";

export default function AdminAppCardHeader({ data, onCancel, setMobileData }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        alignSelf: "stretch",
      }}
    >
      <Typography
        sx={{
          color: "#3A3A3A",
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "28px",
        }}
      >
        Expanded app title
      </Typography>
      <RemoveAction
        data={data}
        onCancel={onCancel}
        setMobileData={setMobileData}
      />
    </Box>
  );
}
